import { render } from "./CannedMessages.vue?vue&type=template&id=54b1080d&scoped=true"
import script from "./CannedMessages.vue?vue&type=script&lang=js"
export * from "./CannedMessages.vue?vue&type=script&lang=js"

import "./CannedMessages.vue?vue&type=style&index=0&id=54b1080d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b1080d"]])

export default __exports__